import { createRoute } from "apps/visits/packages/shared/models/Route";
import { t } from "i18next";

export const routes = {
  validateUser: createRoute("/"),
  codeValidation: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.CODE_VALIDATION")}`),
  catalog: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.CATALOG")}`),
  checkout: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.CHECKOUT")}`),
  thankYou: createRoute<{ uuid: string }>(`/:uuid/${t("VOUCHERS_DISTRIBUTION.ROUTES.THANK_YOU")}`),
  termsAgreement: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.TERMS_AGREEMENT")}`),
};
